import { DatePicker } from "antd";
import { useEffect, useState } from "react";
import { dayjsDate, formatDate2, formatDateTime2 } from "../utils/functions";
import dayjs from 'dayjs';
import zhCN from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

const DateInput = ({value, onChange, showTime = false, style={}})=>{
    const [md, setmd] = useState(null);
    useEffect(()=>{
        setmd(dayjsDate(value));
    },[value]);
    const changeDate = (v)=>{
        const newDate = showTime ? formatDateTime2(v) : formatDate2(v);
        if(onChange){
            onChange(newDate);
        }
        setmd(dayjsDate(newDate));
    }
    return (<DatePicker locale={zhCN} value={md} onChange={changeDate}  showTime={showTime} style={style} />)
}
export default DateInput;